<template lang="pug">
div
  multiselect(
    id="ajax"
    class="multiselect-default"
    v-model="selectedCity"
    :options="options"
    label="label"
    placeholder="Selectionner une ville"
    @search-change="asyncFind"
    select-label=""
    :preserve-search="true"
    :show-labels="false"
  )
    span(slot="noResult") Aucun résultat
    span(slot="noOptions") Commencer à taper pour rechercher

  slot(:selectedCity="selectedCity")
</template>

<script>
import axios from 'axios'
import { debounce } from 'lodash'

export default {
  props: {
    currentCity: {
      type: Object,
      default: () => undefined
    },

    hasError: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      selectedCity: this.currentCity,
      options: []
    }
  },

  methods: {
    asyncFind (query) {
      this.search(query, this)
    },

    search: debounce((query, vm) => {
      axios.get('/api/v1/cities', {
        params: {
          // "Rhone alpes" region code
          by_region_code: '82',
          by_name: query
        }
      })
        .then(({ data: json }) => {
          vm.options = json.data.map(c => {
            return {
              label: c.attributes.name_with_zipcode,
              value: c.id
            }
          })
        })
        .catch()
        .then(() => {

        })
    }, 350)
  }
}
</script>
